<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="announcementInfo" (ngSubmit)="handleSave()">
    <div onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 property-header">Announcment Name</div>
          <mat-form-field appearance="outline" class="form-field">
            <input
              matInput
              #announcementName
              type="text"
              formControlName="announcementName"
              name="announcementName"
              [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_EDIT_NAME"
            />
            <mat-error>{{ getAnnouncementNameError() }}</mat-error>
          </mat-form-field>
        </section>
        <section class="transfer-prop with-mat-form-field">
          <div class="mat-body-1 property-header">Transfer to</div>
          <div class="form-field">
            <onsip-address-autocomplete
              #transferUsername
              [customOptions]="customOptions"
              formControlName="transferUsername"
              name="transferUsername"
            >
            </onsip-address-autocomplete>
          </div>
        </section>
      </div>
      <div class="second-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 property-header">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
          <div class="form-field">
            <onsip-sip-address-field #sipAddress formControlName="sipAddress">
            </onsip-sip-address-field>
          </div>
        </section>
        <section class="name-prop with-mat-form-field">
          <div class="mat-body-1 property-header">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
          <div class="form-field">
            <onsip-extensions-list
              #extensionsList
              formControlName="extensions"
              [currentId]="announcement.appAddress.address.addressId"
            >
            </onsip-extensions-list>
          </div>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button
        mat-button
        class="toggle-button"
        color="primary"
        type="button"
        (click)="togglePanel()"
      >
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button
        mat-flat-button
        class="toggle-button"
        color="primary"
        type="submit"
        [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_EDIT_SUBMIT_BTN"
      >
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
